import axios from '@axios'

export function ServiceBalance() {
  this.balance = () => new Promise((resolve, reject) => {
    axios.get('balances/balance')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject({
          status: err.response.status,
          message: err.response.data.message,
        })
      })
  })
}
export default class ServiceBalanceSpecialist {
  async balanceSpecialist(params) {
    try {
      const resp = await axios.get('balances/balanceSpecialist', { params })
      return resp.data
    } catch (err) {
      return {
        status: err.response.status,
        message: err.response.data.message,
      }
    }
  }
}
